import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { Lock } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function AdminLogin() {
  const { login, user, checked } = useAuth();
  const { t } = useI18n();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (checked && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login("", password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[100svh] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="s-card s-card-pad w-full max-w-md">
        <div className="text-center mb-6">
          <Lock className="mx-auto text-[color:var(--ink-wine)] mb-2" size={28} />
          <p className="eyebrow mb-2">{t.galeria.couplePanel}</p>
          <h1 className="font-script text-4xl text-[color:var(--ink-wine)] leading-none">Selena & Mario</h1>
          <p className="text-sm text-[color:var(--ink-soft)] mt-2">{t.galeria.couplePanelDesc}</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label">{t.galeria.couplePassword}</label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field"
              placeholder={t.galeria.couplePasswordPh}
              autoComplete="current-password"
              required
            />
          </div>
          {err && (
            <div data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md p-3">
              {err}
            </div>
          )}
          <button type="submit" disabled={loading} className="btn-primary" data-testid="admin-login-submit">
            {loading ? "..." : t.galeria.enter}
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link to="/" className="text-[0.7rem] tracking-[0.3em] uppercase font-semibold text-[color:var(--ink-soft)] hover:text-[color:var(--ink-wine)]" data-testid="admin-back-link">
            {t.common.backToWeb}
          </Link>
        </div>
      </div>
    </div>
  );
}
